import {
    QUESTION_TEMPLATE_GET_DATA,
    QUESTION_TEMPLATE_GET_DETAILS_DATA, 
    QUESTION_TEMPLATE_FORM_ADD_DATA,
    QUESTION_TEMPLATE_FORM_UPDATE_DATA,
    QUESTION_TEMPLATE_RESET,
} from './Constants'

// get all question listing
const loadQuestionTemplateDataRequest = () => ({
  type: QUESTION_TEMPLATE_GET_DATA.QUESTION_TEMPLATE_GET_DATA_LOAD,
});
const setQuestionTemplateDataSuccess = (questionlist) => ({
  type: QUESTION_TEMPLATE_GET_DATA.QUESTION_TEMPLATE_GET_DATA_SUCCESS,
  questionlist,
});
const setQuestionTemplateDataFail = (error) => ({
  type: QUESTION_TEMPLATE_GET_DATA.QUESTION_TEMPLATE_GET_DATA_FAIL,
  error,
});

// get by id
const loadQuestionTemplateDetailsDataRequest = (id) => ({
  type: QUESTION_TEMPLATE_GET_DETAILS_DATA.QUESTION_TEMPLATE_GET_DETAILS_DATA_LOAD,
  id,
});
const setQuestionTemplateDetailsDataSuccess = (question) => ({
  type: QUESTION_TEMPLATE_GET_DETAILS_DATA.QUESTION_TEMPLATE_GET_DETAILS_DATA_SUCCESS,
  question,
});
const setQuestionTemplateDetailsDataFail = (error) => ({
  type: QUESTION_TEMPLATE_GET_DETAILS_DATA.QUESTION_TEMPLATE_GET_DETAILS_DATA_FAIL,
  error,
});
//For add  question
const loadQuestionTemplateFormAddDataRequest = (request) => ({
  type: QUESTION_TEMPLATE_FORM_ADD_DATA.QUESTION_TEMPLATE_FORM_ADD_DATA_LOAD,
  request,
});
const setQuestionTemplateFormAddDataSuccess = (questionform) => ({
  type: QUESTION_TEMPLATE_FORM_ADD_DATA.QUESTION_TEMPLATE_FORM_ADD_DATA_SUCCESS,
  questionform,
});
const setQuestionTemplateFormAddDataFail = (error) => ({
  type: QUESTION_TEMPLATE_FORM_ADD_DATA.QUESTION_TEMPLATE_FORM_ADD_DATA_FAIL,
  error,
});
//For Edit question
const loadQuestionTemplateFormUpdateDataRequest = (id,request) => ({
  type: QUESTION_TEMPLATE_FORM_UPDATE_DATA.QUESTION_TEMPLATE_FORM_UPDATE_DATA_LOAD,
  id,request
})

const setQuestionTemplateFormUpdateDataSuccess = (questionform) => ({
  type: QUESTION_TEMPLATE_FORM_UPDATE_DATA.QUESTION_TEMPLATE_FORM_UPDATE_DATA_SUCCESS,
  questionform,
})

const setQuestionTemplateFormUpdateDataFail = (error) => ({
  type: QUESTION_TEMPLATE_FORM_UPDATE_DATA.QUESTION_TEMPLATE_FORM_UPDATE_DATA_FAIL,
  error
})

const resetQuestionState = () => ({
  type: QUESTION_TEMPLATE_RESET,
});


export {
    loadQuestionTemplateDataRequest, setQuestionTemplateDataFail, setQuestionTemplateDataSuccess,
    loadQuestionTemplateDetailsDataRequest, setQuestionTemplateDetailsDataFail, setQuestionTemplateDetailsDataSuccess,
    loadQuestionTemplateFormAddDataRequest, setQuestionTemplateFormAddDataFail, setQuestionTemplateFormAddDataSuccess,
    loadQuestionTemplateFormUpdateDataRequest, setQuestionTemplateFormUpdateDataFail, setQuestionTemplateFormUpdateDataSuccess,
    resetQuestionState,
}